import {toUnixSec, getStartOfDay} from '../../../library/dates';
import {TEticketData, ORDER_STATUS_CANCELED} from '../../../redux/eTicket/eTicket.type';

export type EntranceState = 'canceled' | 'countdown' | 'today' | 'tomorrow' | 'past';

const DAY_SEC = 24 * 60 * 60;
const TWO_HOURS_SEC = 2 * 60 * 60;

export interface EntranceStatusInfo {
    state: EntranceState | null;
    startSec: number | null;
}

export function getEntranceStatus(data: TEticketData | null, now: number): EntranceStatusInfo {
    if(data?.order?.status === ORDER_STATUS_CANCELED)
        return {state: 'canceled', startSec: null};

    const startSec = data?.event?.timeStart != null ? toUnixSec(data.event.timeStart) : NaN;
    if(startSec == null || Number.isNaN(startSec))
        return {state: null, startSec: null};

    const explicitEnd = toUnixSec(data?.event?.timeEnd);
    const endSec = !Number.isNaN(explicitEnd) && explicitEnd > startSec ? explicitEnd : startSec + TWO_HOURS_SEC;
    if(now >= endSec)
        return {state: 'past', startSec};

    const dayDiff = Math.round((getStartOfDay(startSec) - getStartOfDay(now)) / DAY_SEC);
    const state: EntranceState = dayDiff === 0 ? 'today' : dayDiff === 1 ? 'tomorrow' : 'countdown';

    return {state, startSec};
}
